import React from "react";
import styles from "./Wrapper.module.scss";
import { Empty } from "antd";

const CommentsGraphWrapper = ({ children, data, label, desc, loader, width,total }) => {
	return (
		<div className={styles.card} style={{ width }}>
			<h3>{label}</h3>
			<p>{desc}</p>

			{loader ? (
				<div className={styles.loaderBlock}>
					<div className="graph-loader">
						<div className="loader"></div>
					</div>
				</div>
			) : total && total > 0 ? (
				<div className={styles.sourceList}>{children}</div>
			) : (
				<div className={styles.noData}>
					<Empty />
				</div>
			)}
		</div>
	);
};

export default CommentsGraphWrapper;
